import axiosInstance from "../../../api/axiosInstance";

let putMaintenace = async(props, id, user) => {
    let response = '';
    let url=''

    let formulary={
        Nombre: props.attribute,
        UsuarioModificacion: user?.email,
        FechaModificacion: new Date()
    }

    switch(props.type) {
        case "EGT":
            url = process.env.REACT_APP_API + "/certificates/energeticos/update/" + id;
            response = await CallPut(url, formulary);
            break;
        case "EXT":
            url = process.env.REACT_APP_API + "/certificates/retenciones/update/" + id;
            response = await CallPut(url, formulary);
            break;
        case "RT":
            url = process.env.REACT_APP_API + "/medidas/indices/update/" + id;
            response = await CallPut(url, formulary);
            break;
        default:
            response('this code dont exist');
            break;
    }

    return new Promise((resolve) => {     
        resolve(response);
    })
}

let CallPut = async(url, form) => {
    return new Promise((resolve, reject) => {   
        axiosInstance.put(url, form).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export default putMaintenace;